export default {
  tokenKey: 'token',
  sessionDataKey: 'session-data',
  userDataKey: 'user-data',
  userSettingsKey: 'user-settings',
  lastParkingAliasBoughtSubscription: 'last-parking-alias-subscription',
  homeData: 'home-data',

  eventOnLanguageChanged: 'onLanguageChanged',
  eventOnShowNotification: 'onShowNotification',
  eventOnCloseModal: 'onCloseModal',

  eventShowElectricModal: 'eventShowElectricModal',

  apiSelected: 'apiSelected',
  langSelected: 'langSelected',
  citySelected: 'citySelected',

  eventOnAlternativeParkingSelected: 'onAlternativeParkingSelected',

  eventShowToolbar: 'eventShowToolbar',

  eventShowDrawer: 'eventShowDrawer',
  updateUserData: 'onUpdateUserData',
  goToUrl: 'onGoToUrl',

  hideBookingTabs: 'hideBookingTabs',
  blockBooking: 'blockBooking',
  closeReservationDetailAndRefreshCalendar:
    'closeReservationDetailAndRefreshCalendar',
  closeReservationDetail: 'closeReservationDetail',
  showReservationDetail: 'showReservationDetail',

  polBalance: 'polBalance',
  balanceBeforeBuying: 'balanceBeforeBuying',

  oldUserDataKey: 'wesmartpark-user',
  oldTokenKey: 'wesmartpark-keys',

  aws_url: 'aws-url',
  lastSelectedProduct: 'lastSelectedProduct',
  lastSubscription: 'lastSubscription'
};
